import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';

export default function PrevNextBtns({ clsName = '', canPrev = true, canNext = false, onBack, onBackText, onNext, onNextText }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('shared');
    const backText = onBackText || t('calculators.mm100.back');
    const nextText = onNextText || t('calculators.mm100.next');

    return (
        <div className={`calculator-btns calculator-btns-${clsName} ${css.calculatorbtns}`}>
            {canPrev && (
                <button className="btn-back" onClick={onBack} aria-label={backText}>
                    {backText}
                </button>
            )}
            <button className={`btn-next ${!canNext && 'btn-disabled'}`} onClick={onNext} disabled={!canNext} aria-label={nextText}>
                {nextText}
            </button>
        </div>
    );
}
